export const QueryKeys = {
  // Cell Dashboard and Cell Board 2.0 Query Keys
  CELL_DASHBOARD: 'cellDashboard',
  CELL_DASHBOARDS: 'cellDashboards',
  CELL_DASHBOARD_TEMPLATE: 'cellDashboardTemplate',
  CELL_DASHBOARD_TEMPLATES: 'cellDashboardTemplates',
  CELL_BOARD_SAFETY_METRICS: 'cellBoardSafetyMetrics',
  CELL_BOARD_SAFETY_MESSAGES: 'cellBoardSafetyMessages',
  CELL_BOARD_SAFETY_TOPICS: 'cellBoardSafetyTopics',
  CELL_BOARD_NEAR_HIT_INCIDENTS: 'cellBoardNearHitIncidents',
  CELL_BOARD_NEAR_HIT_INCIDENTS_COUNT: 'cellBoardNearHitIncidentsCount',
  CELL_BOARD_FIRST_TIME_PASS_METRICS: 'cellBoardFirstTimePassMetrics',
  CELL_BOARD_FIRST_TIME_PASS_METRICS_DATA: 'cellBoardFirstTimePassMetricsData',
  CELL_BOARD_SUMMARY: 'cellBoardSummary',
  CELL_BOARD_MESSAGE_COUNT: 'cellBoardMessageCount',
  CELL_BOARD_MESSAGE_COUNT_BULK: 'cellBoardMessageCountBulk',
  CELL_BOARD_PRODUCTION_METRIC: 'cellBoardProductionMetric',
  CELL_BOARD_PRODUCTION_METRIC_INTERVALS: 'cellBoardProductionMetricIntervals',
  CELL_BOARD_LABOR_HOURS_PER_UNIT_METRICS: 'cellBoardLaborHoursPerUnitMetrics',
  CELL_BOARD_DATA: 'cellBoardData',
  BREAK_DISPLAY: 'breakDisplay',

  // Cell Board Query Keys
  // lists under [CELL_BOARD_MESSAGES, 'list'], details under [CELL_BOARD_MESSAGES, 'detail']
  CELL_BOARD_MESSAGES: 'cellBoardMessages',
  // lists under [MCELL_MESSAGES, 'list'], details under [MCELL_MESSAGES, 'detail']
  MCELL_MESSAGES: 'mCellMessages',
  CELL_BOARD_CONFIG: 'cellBoardConfig',
  CELL_BOARD_WIDGET_DATA: 'cellBoardWidgetData',
  CELL_BOARD_SAFETY_MESSAGES_BULK: 'cellBoardSafetyMessagesBulk',
  CELL_BOARD_DEFAULT_SAFETY_MESSAGE: 'cellBoardDefaultSafetyMessage',
  CELL_BOARD_SAFETY_TOPIC: 'cellBoardSafetyTopic',
  CELL_BOARD_ENABLED_MCELL_INFOS: 'cellBoardEnabledMCellInfos',
  CELL_BOARD_ROSTER_INVENTORY_CENTER_CONFIGS:
    'cellBoardRosterInventoryCenterConfigs',

  // MCell Alert Query Keys
  MCELL_ALERTS: 'mCellAlerts',
  MCELL_ALERT_POINTS: 'mCellAlertPoints',
  MCELL_ALERT_KEY_MCELL_SCORE: 'mCellAlertKeyMCellScore',

  // Resource Tracking Query Keys
  JOB_STATIONS: 'stations',
  JOB_STATION_ASSIGNMENTS: 'jobStationAssignments',
  CURRENT_MCELL_EMPLOYEE: 'currentMCellEmployee',
  MCELL_EMPLOYEE_BY_BADGE_ID: 'mCellEmployeeByBadgeId',
  HOME_CELL_NOTIFICATION_ENABLED_ICS: 'homeCellNotificationEnabledICs',
  EMPLOYEE_INTERESTS: 'employeeInterests',
  INTEREST_PROFILE: 'interestProfile',
  TOP_MCELLS: 'topMCells',
  MCELL_CAPACITIES: 'mCellCapacities',
  MCELL_STATUSES: 'mCellStatuses',
  MCELL_EMPLOYEE_ACCOUNT_TYPES: 'mCellEmployeeAccountTypes',
  MCELL_EMPLOYEE_ROLES: 'mCellEmployeeRoles',
  MCELL_EMPLOYEE_CATEGORIES: 'mCellEmployeeCategories',
  DEMAND_MANAGEMENT_STATUS_INVENTORY_CENTER_CONFIGS:
    'demandManagementStatusInventoryCenterConfigs',
  DEMAND_MANAGEMENT_STATUS_MCELL_CONFIGS: 'demandManagementStatusMCellConfigs',
  PERSONAL_PROTECTIVE_EQUIPMENTS: 'personalProtectiveEquipments',
  DANGEROUS_EQUIPMENTS: 'dangerousEquipments',

  // LMS Query Keys
  LMS_INTEGRATION_CONFIGS: 'lmsIntegrationConfigs',
  LMS_COURSE_CATALOGS: 'lmsCourseCatalogs',
  LMS_ASSESSMENT_STATUSES: 'lmsAssessmentStatuses',
  LMS_PREVIOUS_SAFETY_COURSE_COMPLETION_METRIC:
    'lmsPreviousSafetyCourseCompletionMetric',
  LMS_CURRENT_SAFETY_COURSE_COMPLETION_METRIC:
    'lmsCurrentSafetyCourseCompletionMetric',
  LMS_PREVIOUS_SAFETY_COURSE_COMPLETION_METRIC_DETAILED_VIEW:
    'lmsPreviousSafetyCourseCompletionMetricDetailedView',
  LMS_CURRENT_SAFETY_COURSE_COMPLETION_METRIC_DETAILED_VIEW:
    'lmsCurrentSafetyCourseCompletionMetricDetailedView',

  // MCell Query Keys
  MCELL: 'mCell',
  MCELLS: 'mCells',
  MCELL_CLONE_PREVIEW: 'mCellClonePreview',
  MCELL_COLLECTIONS: 'mCellCollections',
  MCELL_COMPLETION_CONFIGS: 'mCellCompletionConfigs',
  KEY_MCELLS: 'keyMCells',
  MCELL_SCHEDULE_TEMPLATES: 'mCellScheduleTemplates',
  MCELL_SCHEDULE_TEMPLATE: 'mCellScheduleTemplate',
  MCELL_SCHEDULES: 'mCellSchedules',
  MCELL_SCHEDULE: 'mCellSchedule',

  // MCell Employee Query Keys
  MCELL_EMPLOYEES_IN_MCELL: 'mCellEmployeesInMCell',
  MCELL_EMPLOYEES_LOGGED_IN: 'mCellEmployeesLoggedIn',
  MCELL_EMPLOYEE_SELECTION: 'mCellEmployeeSelection',
  MCELL_EMPLOYEES_LIST: 'mCellEmployeesList',
  EMPLOYEES_LIST: 'employeesList',
  JOB_FUNCTIONS: 'jobFunctions',
  JOB_FUNCTION_TAGS: 'jobFunctionTags',
  MCELL_LOGIN_LAST_UPDATED_DATE: 'mCellLoginLastUpdatedDate',
  EMPLOYEE_REFRESH_STATUS: 'employeeRefreshStatus',

  // Dev Query Keys
  DEV_MCELL_LOGIN_LOGGED_IN_REPORT: 'devMCellLoginLoggedInReport',

  // Home Query Keys
  HOME_LINKS: 'homeLinks',
  HOME_LINK: 'homeLink',
  HOME_LINK_GROUPS: 'homeLinkGroups',

  // LSW Query Keys
  LSW_SHEETS: 'lswSheets',
  LSW_TASK_GROUPS: 'lswTaskGroups',
  LSW_TASKS: 'lswTasks',

  // Manufacturing Location Query Keys
  PRODUCING_LOCATIONS_OPTIONS: 'producingLocations',
  PRODUCTION_LINES_OPTIONS: 'productionLines',
  WORK_CENTERS_OPTIONS: 'workCenters',
  WORK_CENTER_STATIONS_OPTIONS: 'workCenterStations',
  INVENTORY_CENTERS: 'inventoryCenters',
  INVENTORY_CENTER_IDS_BY_MANUFACTURING_LOCATION:
    'inventoryCenterIdsByManufacturingLocation',
  PRODUCING_LOCATIONS: 'producingLocationsList',
  PLANNING_DEPARTMENTS: 'planningDepartments',
  NOTIFICATION_SYSTEM: 'notificationSystem',

  // App Configuration Query Keys
  USER_FEEDBACK: 'userFeedback',
  USER_FEEDBACK_CONFIG: 'userFeedbackConfigs',
  SHAREPOINT_LIBRARIES: 'sharepointLibraries',
  SHAREPOINT_COLUMNS: 'sharepointColumns',
  BREAKTIME_ANNOUNCEMENT_CONFIG: 'breaktimeAnnouncementConfig',
  BREAKTIME_ANNOUNCEMENT_CONFIG_SUMMARIES:
    'breaktimeAnnouncementConfigSummaries',

  // Coatings Query Keys
  COATINGS_BOARD_DATA: 'coatingsBoardData',
  COATINGS_PROFILES: 'coatingsProfiles',
  COATINGS_PROFILE: 'coatingsProfile',
  COATINGS_PAINTS: 'coatingsPaints',

  // Dashboard (Command Center) Query Keys
  DASHBOARDS: 'dashboards',
  DASHBOARD: 'dashboard',
  DASHBOARD_WIDGET_TYPES: 'dashboardWidgetTypes',
  DASHBOARD_WIDGET_DATA: 'dashboardWidgetData',

  // Factory Automation Query Keys
  OVERHEAD_DOOR_SIGNAL_MODE_CONFIGS: 'overheadDoorSignalModeConfigs',

  // Machine Query Keys
  MACHINE_ASSETS: 'machineAssets',

  // Support Hierarchy Query Keys
  MCELL_SUPPORT_HIERARCHY: 'mCellSupportHierarchy',
  SUPPORT_HIERARCHIES: 'supportHierarchies',
  SUPPORT_HIERARCHY_MCELLS: 'supportHierarchyMCells',
  SUPPORT_HIERARCHY_EMPLOYEE_SELECTIONS: 'supportHierarchyEmployeeSelections',
  SUPPORT_GROUPS: 'supportGroups',
  SUPPORT_GROUP_MEMBERS: 'supportGroupMembers',
  DOWNTIME_ESCALATION_OVERRIDES: 'downtimeEscalationOverrides',
  DOWNTIME_ESCALATION_POSITION_OVERRIDES: 'downtimeEscalationPositionOverrides',

  // Downtime Query Keys
  DOWNTIMES: 'downtimes',
  DOWNTIME_REASONS: 'downtimeReasons',
  DOWNTIME_REASON_SUPPORT_GROUP_MAPPINGS: 'downtimeReasonSupportGroupMappings',
  // prefix of the current and all-issues lists
  downtimeLists: () => [QueryKeys.DOWNTIMES, 'list'] as const,
  // prefix of an issue and its escalation assignments
  downtimeDetail: (id: string) => [QueryKeys.DOWNTIMES, 'detail', id] as const,

  // Profile Query Keys
  USER_SETTINGS: 'userSettings',

  // App Query Keys
  HELP_LINKS: 'helpLinks',

  // Taqo Query Keys
  TAQO_PRODUCING_LOCATION_MCELL_MAPPINGS: 'taqoProducingLocationMCellMappings',
  TAQO_PRODUCTION_LINE_OPTIONS: 'taqoProductionLineOptions',
  TAQO_LATEST_AUDIT: 'taqoLatestAudit',
  TAQO_RECENT_AUDITS: 'taqoRecentAudits',

  // Scheduling Tool Query Keys
  ST_PRODUCING_LOCATION_CONFIGS: 'stProducingLocationConfigs',
  ST_PRODUCING_LOCATION_OPTIONS: 'stProducingLocationOptions',
  ST_MCELL_MAPS: 'stMCellMaps',
  ST_MCELL_GUARDRAILS: 'stMCellGuardrails',
  ST_SALES_ORDERS_BY_TYPE: 'stSalesOrdersByType',
  ST_SETTINGS: 'stSettings',
  ST_CHANGE_LOGS: 'stChangeLogs',
  ST_CHANGE_LOG: 'changeLog',
  ST_REASONS: 'reasons',
  ST_REASON: 'reason',
  ST_REFRESH_RUNNING: 'stRefreshRunning',
  ST_CAPACITY_UTILIZATIONS_AGGREGATE: 'stCapacityUtilizationsAggregate',
  ST_CAPACITY_UTILIZATION_EMPLOYEE_METRICS:
    'stCapacityUtilizationEmployeeMetrics',
  ST_LABOR_WHAT_IFS: 'stLaborWhatIfs',
  ST_ORDER_NUMBER_SEARCH: 'stOrderNumberSearch',
  ST_SALES_ORDER_MAIN: 'stSalesOrderMain',
  ST_SALES_ORDER_EXTRA: 'stSalesOrderExtra',
  ST_SALES_ORDER_LINE_ITEMS_PREVIEW: 'stSalesOrderLineItemsPreview',
  ST_SALES_ORDER_LINE_ITEMS_DETAIL: 'stSalesOrderLineItemsDetail',
};
